import React from 'react';
import { DialogUI } from '../Interface';
import { Grid, Box, Typography } from '@mui/material';

const ServiceMonitorWorkAreaDialog = ({ open, handleClose, setFilter, workAreas }) => {
  const handleAreaClick = (workAreaId) => {
    if (!workAreaId) {
      return;
    }

    setFilter((prevState) => ({
      ...prevState,
      workAreaId: workAreaId,
    }));
    handleClose();
  };

  return (
    <DialogUI
      open={open}
      //onClose={handleClose}
      headerContent="Munkaterület"
      fullWidth={true}
      maxWidth="sm"
    >
      <Grid container spacing={1} columnSpacing={0.2} pt={2}>
        {workAreas.length > 0 &&
          workAreas.map((workArea) => (
            <Grid item xs={6} p={2} key={workArea.id}>
              <Box
                onClick={() => handleAreaClick(workArea.id)}
                sx={{
                  height: '120px',
                  display: 'flex',
                  flexDirection: 'column', // stack code and name
                  alignItems: 'center',
                  justifyContent: 'center',
                  textAlign: 'center',
                  color: 'rgb(22, 163, 74)', // sötétebb zöld szöveg
                  backgroundColor: 'rgba(187, 247, 208, 0.3)', // világosabb zöld háttér
                  border: '2px solid rgb(22, 163, 74)', // keret színe megegyezik a betű színével
                  borderRadius: '12px',
                  fontSize: '2rem', // nagy betű (code)
                  fontWeight: 700,
                  cursor: 'pointer',
                  userSelect: 'none',
                }}
              >
                <Typography sx={{ fontSize: '2rem', fontWeight: 700, lineHeight: 1 }}>{workArea.code}</Typography>
                <Typography sx={{ fontSize: '0.85rem', fontWeight: 500, lineHeight: 1.2 }}>{workArea.name}</Typography>
              </Box>
            </Grid>
          ))}
      </Grid>
    </DialogUI>
  );
};

export default ServiceMonitorWorkAreaDialog;
